export enum ReferenceFeatures {
  DL_MASTER = 'dl master',
  DL_PLAN = 'dl plan',
  PA_REQUEST_LIST = 'pa request list'
}

export enum OrderType {
  TrimOrder = 'Trim Order',
  FinishedGoodsOrder = 'Finished Goods Order',
  FabricOrder = 'Fabric Order',
}